export class ConstantsUtils{

  public static readonly COR_PRIMARIA: string = 'corPrimaria'
  public static readonly COR_TEXTO_PRIMARIA: string = 'corTextoPrimaria'
  public static readonly COR_SECUNDARIA: string = 'corSecundaria'
  public static readonly COR_TEXTO_SECUNDARIA: string = 'corTextoSecundaria'
  public static readonly COR_AUXILIAR: string = 'corAuxiliar'
  public static readonly COR_TEXTO_AUXILIAR: string = 'corTextoAuxiliar'
  public static readonly PREFIXO_GRUPO: string = 'prefixo'
  public static readonly AMBIENTE_LOCAL_STORAGE_KEY: string = "ambiente";
  public static readonly RESOLUCAO_MOBILE: number = 1024

  public static readonly COR_PRIMARIA_HEX: string = '#FF7246'
  public static readonly COR_TEXTO_PRIMARIA_HEX: string = '#ffffff'
  public static readonly COR_SECUNDARIA_HEX: string = '#2B2B2B'
  public static readonly COR_TEXTO_SECUNDARIA_HEX: string = '#ffffff'
  public static readonly COR_AUXILIAR_HEX: string = '#E5E5E5'
  public static readonly COR_TEXTO_AUXILIAR_HEX: string = '#ffffff'
  public static readonly SECRET_KEY = "e47f74ac9848d1c7ccdb5d7256ab35aASGFDGHasdfKJasdfLASDF*5asdf";
}
